import styled from "styled-components";

import colors from "../theme/colors";

export const Main = styled.section`
  margin-top: 10px;
  background-color: white;
  min-height: 360px;
  height: 100%;
  border-radius: 6px;
  padding: 5px;
`;

export const ImgHeader = styled.img`
  height: 34px;
  width: auto;
  margin: 0px 23px;
  margin-bottom: 11px;
`;

export const ImgFooter = styled.img`
  height: 34px;
  width: auto;
  margin: 0px 8px;
  //margin-bottom: 11px;
`;

export const Title = styled.h3`
  color: ${colors.primary};
  margin: 0px 24px;
`;
